import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button, Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { newdoctor } from "../../../constants/Validation";
import { useDispatch, useSelector } from "react-redux";
import {
  citylist,
  refTypesList,
} from "../../../redux/actions/dbactions/refactions";
import { getSession } from "../../../redux/actions/authActions";
import { createNewDoctor } from "../../../redux/actions/dbactions/facilityActions";

const NewDoctor = ({ handleCloseModal }) => {
  const dispatch = useDispatch();
  const { user_profile_id, role_id } = getSession();
  const { refsdata } = useSelector((state) => state.refstypes);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState("");

  useEffect(() => {
    dispatch(refTypesList());
  }, [dispatch]);

  const countryname = refsdata.usr?.iso_cntry || [];
  const citiesName = citis.usr?.iso_city || [];
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCountryChange = (event, setFieldValue) => {
    const selectedCountryId = event.target.value;
    setFieldValue("iso_cntry_id", selectedCountryId);
    dispatch(citylist(selectedCountryId));

    if (selectedCountryId) {
      setIsCountrySelected(true);
      setFieldValue("addr_state", ""); // Clear city field when a new country is selected
      setSelectedCityId("");
    } else {
      setIsCountrySelected(false);
    }
  };

  const handleCityChange = (event, setFieldValue) => {
    const selectedCityId = event.target.value;
    if (selectedCityId) {
      setSelectedCityId(selectedCityId);
      setFieldValue("iso_city_id", selectedCityId);
    } else {
      setSelectedCityId("");
      setFieldValue("iso_city_id", "");
      setFieldValue("addr_state", "");
      setFieldValue("addr_zipcode", "");
    }
  };
  const newDoctor = async (values) => {
    setIsSubmitting(true); // Set loading state to true
    const submissionValues = {
      user_profile_id: user_profile_id,
      provider_name: values.provider_name,
      user_phone_nbr: values.user_phone_nbr,
      addr_street1: values.addr_street1,
      iso_city_id: selectedCityId,
      iso_cntry_id: values.iso_cntry_id,
      sys_active_yn: values.sys_active_yn,
      sys_user_id: user_profile_id,
      role_id: role_id,
    };
    await dispatch(createNewDoctor(submissionValues)); // Wait for the dispatch to complete
    setIsSubmitting(false); // Set loading state to false
    handleCloseModal(); // Close the modal after submission
  };

  return (
    <div className="profile">
      <div className="card_white_box">
        <Formik
          initialValues={{
            provider_name: "",
            user_phone_nbr: "",
            addr_street1: "",
            iso_city_id: "",
            addr_zipcode: "",
            addr_state: "",
            iso_cntry_id: "",
            sys_active_yn: "N",
            sys_user_id: user_profile_id,
            user_profile_id: user_profile_id,
            role_id: role_id,
            user_id: 5,
          }}
          validationSchema={newdoctor}
          onSubmit={(values) => {
            newDoctor(values);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <p>
                  We will reach-out to this service provider and onboard them in
                  2 business days! You can also call customer support.
                </p>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.provider_name && errors.provider_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="provider_name"
                      placeholder="Service provider name"
                      type="input"
                    />
                    <ErrorMessage name="provider_name" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.user_phone_nbr && errors.user_phone_nbr
                          ? "is-invalid"
                          : ""
                      }`}
                      name="user_phone_nbr"
                      type="input"
                      placeholder="Mobile number"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.addr_street1 && errors.addr_street1
                          ? "is-invalid"
                          : ""
                      }`}
                      name="addr_street1"
                      placeholder="Address line 1"
                      type="input"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Select
                      className="form-control"
                      name="iso_cntry_id"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                    >
                      <option value="">Select Country</option>
                      {countryname.map((item, index) => (
                        <option key={index} value={item.iso_cntry_id}>
                          {item.iso_cntry_name}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage name="iso_cntry_id" component={Texterror} />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <div className="position-relative">
                      <Form.Select
                        className="form-control"
                        name="iso_city_id"
                        aria-label="Default select example"
                        onChange={(e) => handleCityChange(e, setFieldValue)}
                        disabled={!isCountrySelected}
                      >
                        <option value="">Select City</option>
                        {isCountrySelected &&
                          citiesName.map((city) => (
                            <option
                              key={city.iso_city_id}
                              value={city.iso_city_id}
                            >
                              {city.iso_city_name}
                            </option>
                          ))}
                      </Form.Select>
                      {citiesLoading && (
                        <div className="loader-container">
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="primary"
                          />
                        </div>
                      )}
                    </div>
                    <ErrorMessage name="iso_city_id" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mini_edit justify-end">
                    <Button
                      className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                      variant="secondary"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="w-full sign_btn !rounded-md !bg-primary-blue h-[43px] !min-w-20 !border-b-color text-white !text-sm"
                      variant="primary"
                      type="submit"
                      disabled={
                        isSubmitting ||
                        !values.provider_name ||
                        !values.iso_city_id
                      }
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner animation="border" variant="primary" />
                        </>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default withRouter(NewDoctor);
